import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors } from '@mui/material';
import { Page, Header } from 'components';
import ConfigurationNokiaForm from './components/ConfigurationNokiaForm';
import ConfigurationHuaweiForm from './components/ConfigurationHuaweiForm';
import DumpsDataTable from './components/DumpsDataTable';
import { LastDumpsUpdate } from '../../actions/ConfigurationActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Configuration = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const dumps = useSelector(state => state.configurationReducer.dumps);

	const _getData = useCallback(() => {
		dispatch(LastDumpsUpdate());
	}, []);

	useEffect(() => {
		_getData();
	}, []);

	return (
		<Page className={classes.root} title="CM">
			<Header module="CM" view="Configuration" />
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={6} xs={12}>
						<div className={clsx(classes.container)}>
							<ConfigurationNokiaForm className={classes.content} />
						</div>
						<div className={clsx(classes.container)}>
							<ConfigurationHuaweiForm className={classes.content} />
						</div>
					</Grid>
					<Grid item md={6} xs={12}>
						<DumpsDataTable data={dumps} />
					</Grid>
				</Grid>
			</CardContent>
		</Page>
	);
};

export default Configuration;
